import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Users16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.25 4C2.25 2.48122 3.48122 1.25 5 1.25C6.51878 1.25 7.75 2.48122 7.75 4C7.75 5.51878 6.51878 6.75 5 6.75C3.48122 6.75 2.25 5.51878 2.25 4ZM5 2.75C4.30964 2.75 3.75 3.30964 3.75 4C3.75 4.69036 4.30964 5.25 5 5.25C5.69036 5.25 6.25 4.69036 6.25 4C6.25 3.30964 5.69036 2.75 5 2.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 4.25C9.48122 4.25 8.25 5.48122 8.25 7C8.25 8.51878 9.48122 9.75 11 9.75C12.5188 9.75 13.75 8.51878 13.75 7C13.75 5.48122 12.5188 4.25 11 4.25ZM9.75 7C9.75 6.30964 10.3096 5.75 11 5.75C11.6904 5.75 12.25 6.30964 12.25 7C12.25 7.69036 11.6904 8.25 11 8.25C10.3096 8.25 9.75 7.69036 9.75 7Z'
      fill='currentColor'
    />
    <path
      d='M9 10.25C7.48122 10.25 6.25 11.4812 6.25 13V14H7.75V13C7.75 12.3096 8.30964 11.75 9 11.75H13C13.6904 11.75 14.25 12.3096 14.25 13V14H15.75V13C15.75 11.4812 14.5188 10.25 13 10.25H9Z'
      fill='currentColor'
    />
    <path
      d='M3 7.25C1.48122 7.25 0.25 8.48122 0.25 10V11H1.75V10C1.75 9.30964 2.30964 8.75 3 8.75H7V7.25H3Z'
      fill='currentColor'
    />
  </Svg>
);

Users16.displayName = 'Users16';
export default Users16;
